let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("X0Jic")).then(() => parcelRequire('cNrRQ'));